import { create } from "zustand";
import { API_GET_MAMBOO } from "services";
import { getCookie } from "services/cookies";

const useLoginStore = create((set) => {
  const storedProfile = JSON.parse(localStorage.getItem("userProfile")) || {};

  return {
    // Cache tampilan (nama, foto, dsb) dari localStorage.
    // TIDAK boleh dipakai untuk menentukan hak akses: isinya bisa diubah sendiri
    // oleh user lewat devtools.
    profile: storedProfile,

    // Profil hasil pemanggilan GET /api/user/profile. Ini satu-satunya sumber
    // `role_code` dan `access` yang boleh dipakai untuk gating menu/route.
    serverProfile: null,
    // Saat belum login tidak ada yang perlu diverifikasi.
    isLoadingServerProfile: Boolean(getCookie("auth_token")),

    // Penanda bahwa upaya pengambilan profil sudah selesai — baik berhasil
    // maupun gagal. Dipakai penjaga rute untuk membedakan "belum pernah
    // dicoba" dari "sudah dicoba dan hasilnya kosong". Tanpa ini, alur yang
    // lupa memanggil fetchServerProfile (mis. registrasi) membuat penjaga
    // mengira profilnya memang tidak ada dan halaman terlanjur dirender.
    hasResolvedServerProfile: false,

    isVerified: false,
    setIsVerified: (state) => {
      set({ isVerified: state });
    },
    setProfile: (state) => {
      set({ profile: state });
      localStorage.setItem("userProfile", JSON.stringify(state));
    },
    deleteProfile: () => {
      set({
        profile: {},
        serverProfile: null,
        isLoadingServerProfile: false,
        hasResolvedServerProfile: false,
      });
      localStorage.removeItem("userProfile");
    },

    /**
     * Ambil ulang profil dari server. Dipanggil saat aplikasi dimuat dan setiap
     * kali login berhasil. Mengembalikan data profil, atau null bila gagal.
     */
    fetchServerProfile: async () => {
      set({ isLoadingServerProfile: true });
      try {
        const data = await API_GET_MAMBOO.dynamic.getProfile();
        set({
          serverProfile: data,
          isLoadingServerProfile: false,
          hasResolvedServerProfile: true,
        });
        return data;
      } catch (error) {
        set({
          serverProfile: null,
          isLoadingServerProfile: false,
          hasResolvedServerProfile: true,
        });
        return null;
      }
    },
  };
});

export default useLoginStore;
